import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { SpheraNotificationGroup, SpheraNotification, SpheraButtonEx } from "@sphera-cloud/component-ui-reactjs";
import { CustomColumnWidthsModal } from './CustomColumnWidthsModal';
import { PublicSiteForm } from '../PublicSiteForm';

export const AddEditPublicSiteModal = (props) => {
    const [showWidthModal, setshowWidthModal] = React.useState(false);
    const [showDetails, setshowDetails] = React.useState(false);
    const [showMaterial, setshowMaterial] = React.useState(false);

    const toggleWidthsModal = (isMaterial) => {
        setshowWidthModal(!showWidthModal);

        if (showWidthModal) {
            setshowDetails(false);
            setshowMaterial(false);
        }
        else {
            if (!isMaterial) {
                setshowDetails(true);
                setshowMaterial(false);
            }
            else {
                setshowMaterial(true);
                setshowDetails(false);
            }
        }
    }

    return (
        <>
            <Modal
                isOpen={props.showModal}
                toggle={props.toggle}
                size="lg" style={{ maxWidth: '1000px', width: '100%' }}
            >
                <ModalHeader toggle={props.toggle}>
                    {props.localizations.AddEditSite}
                </ModalHeader>
                <ModalBody>
                    <PublicSiteForm localizations={props.localizations} siteNameValid={props.siteNameValid} setSiteNameValid={props.setSiteNameValid} siteUrlValid={props.siteUrlValid} setSiteUrlValid={props.setSiteUrlValid}
                        tokenValid={props.tokenValid} setTokenValid={props.setTokenValid} apiTokens={props.apiTokens} loginConfig={props.loginConfig}
                        baseDomain={props.portalBaseDomain} isDuplicate={props.isDuplicate} materialColumns={props.materialColumns}
                        allMaterialColumns={props.allMaterialColumns}
                        documentColumns={props.documentColumns} includecustomcolumn1Change={props.includecustomcolumn1Change} setmaterialColumns={props.setmaterialColumns}
                        setdocumentColumns={props.setdocumentColumns} selectedSite={props.selectedSite} setselectedSite={props.setselectedSite}
                        colorValue={props.colorValue} DefaultTextValue={props.DefaultTextValue} handlecolorValueChange={props.handlecolorValueChange}
                        handleDefaultTextValueChange={props.handleDefaultTextValueChange} toggleWidthsModal={toggleWidthsModal}
                        propscheckChange={props.propscheckChange} propOnDragOver={props.propOnDragOver} propOnNavigate={props.propOnNavigate} PhraseSectionCustomer={props.PhraseSectionCustomer}
                        removeLogo={props.removeLogo} changeHandler={props.changeHandler} uploadedFile={props.uploadedFile} logoUrl={props.logoUrl} loadingLogo={props.loadingLogo}
                        handleFilterDropdownChange={props.handleFilterDropdownChange} filtersDropdownData={props.filtersDropdownData} filterSelected={props.filterSelected} handleDefaultTextDropdownChange={props.handleDefaultTextDropdownChange} defaultTextDropdownData={props.defaultTextDropdownData} defaultTextSelected={props.defaultTextSelected}  />
                </ModalBody>
                <ModalFooter>
                    <SpheraButtonEx className='cancelBtn' text={props.localizations.Cancel} onClick={props.modalCancelClick} />
                    <SpheraButtonEx primary text={props.localizations.Save} onClick={props.modalSaveClick} />
                </ModalFooter>
                <SpheraNotificationGroup
                    position={{
                        left: '45%',
                        bottom: '2.5rem',
                        alignItems: "flex-center",
                    }}>
                    {props.error && <SpheraNotification closable={true}
                        type="error"
                        theme="dark"
                        text={props.localizations.SaveError + ": " + props.errorMessage}
                        onClose={() => props.setError(false)} />}
                </SpheraNotificationGroup>
            </Modal>
            <CustomColumnWidthsModal localizations={props.localizations} toggleWidthsModal={toggleWidthsModal} showWidthModal={showWidthModal}
                materialColumns={props.materialColumns} documentColumns={props.documentColumns} showMaterial={showMaterial} showDetails={showDetails}
                setmaterialColumns={props.setmaterialColumns} setdocumentColumns={props.setdocumentColumns} />
        </>
    );
};
